import {Pipe, PipeTransform} from '@angular/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'isAuthorisationInProgress',
  standalone: true
})
export class IsAuthorisationInProgressPipe implements PipeTransform {
  transform(versions): any {
    return !!versions.filter(v => v.state === DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED).length;
  }
}
